import { PagedResultDto } from '@shared/components/paged-listing-component-base';
import { TestDto } from './test-dto';

export class TestPagedResultDto extends PagedResultDto {
  public items: TestDto[] = [];
}
